<!-- Zweck: Stellt die HTML-Struktur für shop warenkorb action info component im Frontend bereit. -->
@if (data) {
  <div (keydown)="keydown($event)" class="infobox">
    <table>
      <tr>
        <td>
          @if (data.action == 'add') {
            <span>
              <svg-icon [size]="80" [class.infoicon-green]="data.info.state == 'success'" class="infoicon">success</svg-icon>
            </span>
          }
          @if (data.action == 'delete') {
            <span>
              <svg-icon [size]="80" [class.infoicon-green]="data.info.state == 'success'"
              class="infoicon">loeschen</svg-icon>
            </span>
          }
          @if (data.action == 'wkdelete') {
            <span>
              <svg-icon [size]="80" [class.infoicon-green]="data.info.state == 'success'" class="infoicon">loeschen</svg-icon>
            </span>
          }
          @if (data.action == 'wkempty') {
            <span>
              <svg-icon [size]="80" [class.infoicon-green]="data.info.state == 'success'" class="infoicon">error-clean</svg-icon>
            </span>
          }
          @if (data.action == 'fastOrdered') {
            <span>
              <svg-icon [size]="80" [class.infoicon-green]="data.info.state == 'success'" class="infoicon">success</svg-icon>
            </span>
          }
        </td>
        <td>
          {{data.info.message}}
        </td>
      </tr>
    </table>
  </div>
}
